/* eslint-disable */
export default {
    state: {
        icon: '',
        title: '',
        isProject: false,
        isExperimental: false,
        activeSec: '',
    },
    getters: {
        title: state => state.title,
        icon: state => state.icon,
        isProject: state => state.isProject,
        isExperimental: state => state.isExperimental,
        activeSec: state => state.activeSec
    },
    mutations: {
        icon(state, val) {
            state.icon = val
        },
        title(state, val) {
            state.title = val
        },
        isProject(state, val) {
            state.isProject = val
        },
        isExperimental(state, val) {
            state.isExperimental = val
        },
        activeSec(state, val) {
            state.activeSec = val
        },
    },
    actions: {},
}